<template>
  <div>
    <Loader v-if="isLoading" size="lg"></Loader>
    <div v-else>
      <div v-if="items.length > 0">
        <table class="table table-sm table-responsive-lg table-hover table-striped">
          <thead>
            <tr>
              <th></th>
              <th class="w-2"></th>
              <th>
                <span @click="changeOrder('id')" class="th-link">
                  {{$t('views.excmcase.list.id')}}
                </span>
                <i v-if="order['id']" :class="{'fas fa-sort-down': order['id'] === 'desc', 'fas fa-sort-up': order['id'] === 'asc'}"></i>
              </th>
              <th>
                  {{$t('views.excmcase.form.contractorUserData')}}
              </th>
              <th v-if="displayAssigned">
                <span @click="changeOrder('lastTask.lastPoolTask.operationTransferUserData.surname')">{{$t('modals.finishedTaskDocument.idDoneByUserData')}}</span>
                <i v-if="order['lastTask.lastPoolTask.operationTransferUserData.surname']" :class="{'fas fa-sort-down': order['lastTask.lastPoolTask.operationTransferUserData.surname'] === 'desc', 'fas fa-sort-up': order['lastTask.lastPoolTask.operationTransferUserData.surname'] === 'asc'}"></i>
              </th>
              <th class="text-center">
                <span @click="changeOrder('sortByProgress')" class="th-link">
                  {{ $t('views.excmtask.list.progress') }}
                </span>
                <i v-if="order['sortByProgress']" :class="{'fas fa-sort-down': order['sortByProgress'] === 'desc', 'fas fa-sort-up': order['sortByProgress'] === 'asc'}"></i>
              </th>
              <th class="text-center">
                <span @click="changeOrder('lastTask.taskSortByProgress')" class="th-link">
                  {{$t('views.excmcase.show.currentTask')}}
                </span>
                <i v-if="order['lastTask.taskSortByProgress']" :class="{'fas fa-sort-down': order['lastTask.taskSortByProgress'] === 'desc', 'fas fa-sort-up': order['lastTask.taskSortByProgress'] === 'asc'}"></i>
              </th>
              <th class="text-center">
                  {{$t('views.excmcase.show.keyTask')}}
              </th>
              <th style="width: 20%">
                {{$t('views.excmcase.form.partnerUserData')}}
              </th>
              <th class="text-center">
                <span @click="changeOrder('caseType.title')" class="th-link">
                  {{$t('views.excmcasetype.list.table.title')}}
                </span>
                <i v-if="order['caseType.title']" :class="{'fas fa-sort-down': order['caseType.title'] === 'desc', 'fas fa-sort-up': order['caseType.title'] === 'asc'}"></i>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" class="p-2" :key="item['@id']">
              <td class="text-center">
                <b-form-checkbox
                  v-if="getIdLink(item.status['@id']) === '1' && isOpenCasesTable"
                  v-model="selectedItems"
                  :value="item"
                  :disabled="isItemDisabledForSelect(item)"
                ></b-form-checkbox>
              </td>
              <td>
                <span v-b-tooltip.hover :title="item.status.title" class="h6 mt-0 mb-0">
                    <i :class="item.status.class + ' fa-lg mr-2'" :style="'color: ' + item.status.color"></i>
                </span>
              </td>
              <td>
                <router-link v-if="hasAllowedRoles || ableToManageThisCase(item)"
                  :to="{name: 'EXCMCaseShow', params: { id: item['@id'] }}">
                  <span v-if="item.number">{{item.number}}</span>
                  <span v-else>{{getIdLink(item['@id'])}}</span>
                </router-link>
                <span v-else>
                  <span v-if="item.number">{{item.number}}</span>
                  <span v-else>{{getIdLink(item['@id'])}}</span>
                </span>
              </td>
              <td>
                <div v-if="item.contractorUserData">
                  <span v-if="item.contractorUserData.firmname1">{{item.contractorUserData.firmname1}}</span>
                  <span v-else-if="item.contractorUserData.fullName">{{item.contractorUserData.fullName}}</span>
                  <div v-if="item.contractorUserData.phone">{{$t('views.excmcase.show.phone')}}: <phoneNumberLink :phoneNumber="item.contractorUserData.phone"/></div>
                  <div v-if="item.contractorUserData.mobilePhone">{{$t('views.excmcase.show.mobilePhone')}}: <phoneNumberLink :phoneNumber="item.contractorUserData.mobilePhone"/></div>
                  <div>{{ item.contractorUserData.fullAddress }}</div>
                  <div v-if="item.contractorUserData.userEmail"><a :href="'mailto:' + item.contractorUserData.userEmail">{{ item.contractorUserData.userEmail }}</a></div>
                  <div v-if="item.contractorUserData.contactEmail"><a :href="'mailto:' + item.contractorUserData.contactEmail">{{ item.contractorUserData.contactEmail }}</a></div>
                </div>
              </td>
              <td v-if="displayAssigned">
                <div v-if="item.notFinishedTasks && item.notFinishedTasks.length > 1">
                  <div v-for="(notFinishedTask, notFinishedTaskKey) in item.notFinishedTasks" class="mx-2" :key="notFinishedTaskKey">
                    <hr class="mt-2 mb-2" v-if="notFinishedTaskKey > 0">
                    {{ getLastPoolTaskServiceman(notFinishedTask) }}
                  </div>
                </div>
                <div v-else-if="item.lastTask && item.lastTask.poolTask && item.lastTask.poolTask.length > 0">
                  {{getLastPoolTaskServiceman(item.lastTask)}}
                </div>
              </td>
              <td class="text-center">
                <div v-if="item.deadlineDate">
                  <b-badge :variant="getProgress(item) > 100 ? 'danger' : null">
                    {{ getProgress(item) > 100 ? $t('views.excmtask.list.deadlineExceeded') : getProgress(item) + ' %' }}
                  </b-badge>
                  <deadline-date-info :item="item"/>
                  <small class="d-block">
                    {{ $moment(item.createdAt).format('YYYY-MM-DD HH:mm') }}
                  </small>
                  <small class="d-block">
                    {{' - ' + $moment(item.deadlineDate).format('YYYY-MM-DD HH:mm')}}
                  </small>
                  <Progress
                    v-if="getProgress(item) < 100"
                    :type="'primary'"
                    :value="getProgress(item)">
                  </Progress>
                </div>
                <b-badge v-else>
                  {{ $t('views.excmcase.list.noDeadlineDate') }}
                </b-badge>
              </td>
              <td v-if="item.notFinishedTasks && item.notFinishedTasks.length > 1" class="text-center">
                <div v-for="(notFinishedTask, notFinishedTaskKey) in item.notFinishedTasks" class="mx-2" :key="notFinishedTaskKey">
                  <hr class="mt-2 mb-2" v-if="notFinishedTaskKey > 0">
                  {{notFinishedTask.idTaskType.title}}
                  <div v-for="(customField, index) in notFinishedTask.customFields" v-bind:key="index" v-show="notFinishedTask.canViewDetails && !isRoleForCustomFieldDisabled(customField)">
                    <p class="m-0" v-if="customField.label && customField.type === 'datetime'">{{customField.label}}: <span v-if="customField.value">{{$moment(customField.value).format('YYYY-MM-DD')}}</span><span v-else>{{$t('null')}}</span></p>
                    <p class="m-0" v-else-if="customField.name && customField.type === 'datetime'">{{customField.name}}: <span v-if="customField.value">{{$moment(customField.value).format('YYYY-MM-DD')}}</span><span v-else>{{$t('null')}}</span></p>
                    <p class="m-0" v-else-if="customField.type === 'multiSelect'">{{customField.label}}: <span v-if="customField.value.length > 0">{{customField.value.join(', ')}}</span><span v-else>{{$t('null')}}</span> </p>
                    <p class="m-0" v-else-if="customField.label && customField.value">{{customField.label}}: {{(customField.value)}}</p>
                    <p class="m-0" v-else-if="customField.name && customField.value">{{customField.name}}: {{(customField.value)}}</p>
                  </div>
                  <div v-if="notFinishedTask.deadlineDate">
                    <b-badge :variant="getProgress(notFinishedTask) > 100 ? 'danger' : null">
                      {{ getProgress(notFinishedTask) > 100 ? $t('views.excmtask.list.deadlineExceeded') : getProgress(notFinishedTask) + ' %' }}
                    </b-badge>
                    <deadline-date-info :item="notFinishedTask"/>
                    <small class="d-block">
                      {{ $moment(notFinishedTask.createdAt).format('YYYY-MM-DD HH:mm') }}
                    </small>
                    <small class="d-block">
                      {{' - ' + $moment(notFinishedTask.deadlineDate).format('YYYY-MM-DD HH:mm')}}
                    </small>
                    <Progress
                      v-if="getProgress(notFinishedTask) < 100"
                      :type="'primary'"
                      :value="getProgress(notFinishedTask)">
                    </Progress>
                  </div>
                  <b-badge v-else>
                    {{ $t('views.excmcase.list.noDeadlineDate') }}
                  </b-badge>
                </div>
              </td>
              <td v-else-if="item.lastTask" class="text-center">
                <div class="mx-2">
                  {{item.lastTask.idTaskType.title}}
                  <div v-for="(customField, index) in item.lastTask.customFields" v-bind:key="index" v-show="item.lastTask.canViewDetails && !isRoleForCustomFieldDisabled(customField)">
                    <p class="m-0" v-if="customField.label && customField.type === 'datetime'">{{customField.label}}: <span v-if="customField.value">{{$moment(customField.value).format('YYYY-MM-DD')}}</span><span v-else>{{$t('null')}}</span></p>
                    <p class="m-0" v-else-if="customField.name && customField.type === 'datetime'">{{customField.name}}: <span v-if="customField.value">{{$moment(customField.value).format('YYYY-MM-DD')}}</span><span v-else>{{$t('null')}}</span></p>
                    <p class="m-0" v-else-if="customField.type === 'multiSelect'">{{customField.label}}: <span v-if="customField.value.length > 0">{{customField.value.join(', ')}}</span><span v-else>{{$t('null')}}</span> </p>
                    <p class="m-0" v-else-if="customField.label && customField.value">{{customField.label}}: {{(customField.value)}}</p>
                    <p class="m-0" v-else-if="customField.name && customField.value">{{customField.name}}: {{(customField.value)}}</p>
                  </div>
                  <div v-if="item.lastTask.deadlineDate">
                    <b-badge :variant="getProgress(item.lastTask) > 100 ? 'danger' : null">
                      {{ getProgress(item.lastTask) > 100 ? $t('views.excmtask.list.deadlineExceeded') : getProgress(item.lastTask) + ' %' }}
                    </b-badge>
                    <deadline-date-info :item="item.lastTask"/>
                    <small class="d-block">
                      {{ $moment(item.lastTask.createdAt).format('YYYY-MM-DD HH:mm') }}
                    </small>
                    <small class="d-block">
                      {{' - ' + $moment(item.lastTask.deadlineDate).format('YYYY-MM-DD HH:mm')}}
                    </small>
                    <Progress
                      v-if="getProgress(item.lastTask) < 100"
                      :type="'primary'"
                      :value="getProgress(item.lastTask)">
                    </Progress>
                  </div>
                  <b-badge v-else>
                    {{ $t('views.excmcase.list.noDeadlineDate') }}
                  </b-badge>
                </div>
              </td>
              <td v-else></td>
              <td v-if="item.idKeyTask" class="text-center">
                <div class="mx-2">
                  {{item.idKeyTask.idTaskType.title}}
                  <strong v-if="item.idKeyUserData"><br>{{item.idKeyUserData.name}} {{item.idKeyUserData.surname}}</strong>
                  <div v-for="(customField, index) in item.idKeyTask.customFields" v-bind:key="index" v-show="item.idKeyTask.canViewDetails && !isRoleForCustomFieldDisabled(customField)">
                    <p class="m-0" v-if="customField.label && customField.type === 'datetime'">{{customField.label}}: <span v-if="customField.value">{{$moment(customField.value).format('YYYY-MM-DD')}}</span><span v-else>{{$t('null')}}</span></p>
                    <p class="m-0" v-else-if="customField.name && customField.type === 'datetime'">{{customField.name}}: <span v-if="customField.value">{{$moment(customField.value).format('YYYY-MM-DD')}}</span><span v-else>{{$t('null')}}</span></p>
                    <p class="m-0" v-else-if="customField.type === 'multiSelect'">{{customField.label}}: <span v-if="customField.value.length > 0">{{customField.value.join(', ')}}</span><span v-else>{{$t('null')}}</span> </p>
                    <p class="m-0" v-else-if="customField.label && customField.value">{{customField.label}}: {{(customField.value)}}</p>
                    <p class="m-0" v-else-if="customField.name && customField.value">{{customField.name}}: {{(customField.value)}}</p>
                  </div>
                  <div v-if="item.idKeyTask.deadlineDate">
                    <b-badge :variant="getProgress(item.idKeyTask) > 100 ? 'danger' : null">
                      {{ getProgress(item.idKeyTask) > 100 ? $t('views.excmtask.list.deadlineExceeded') : getProgress(item.idKeyTask) + ' %' }}
                    </b-badge>
                    <small class="d-block">
                      {{ $moment(item.idKeyTask.createdAt).format('YYYY-MM-DD HH:mm') }}
                    </small>
                    <small class="d-block">
                      {{' - ' + $moment(item.idKeyTask.deadlineDate).format('YYYY-MM-DD HH:mm')}}
                    </small>
                    <Progress
                      v-if="getProgress(item.idKeyTask) < 100"
                      :type="'primary'"
                      :value="getProgress(item.idKeyTask)">
                    </Progress>
                  </div>
                  <b-badge v-else>
                    {{ $t('views.excmcase.list.noDeadlineDate') }}
                  </b-badge>
                </div>
              </td>
              <td v-else></td>
              <td>
                <div v-if="item.partnerUserData">
                  <span v-if="item.partnerUserData.firmname1">
                    {{item.partnerUserData.firmname1}}
                  </span>
                  <span v-else-if="item.partnerUserData.fullName">
                    {{item.partnerUserData.fullName}}
                  </span>
                  <div v-if="item.partnerUserData.userEmail">
                    <a :href="'mailto:' + item.partnerUserData.userEmail">
                      {{ item.partnerUserData.userEmail }}
                    </a>
                  </div>
                  <div v-if="item.partnerUserData.contactEmail">
                    <a :href="'mailto:' + item.partnerUserData.contactEmail">
                      {{ item.partnerUserData.contactEmail }}
                    </a>
                  </div>
                </div>
              </td>
              <td>
                <span v-b-tooltip.hover :title="$t('views.excmcase.form.idPriority') + ' ' + item.idPriority.title" v-if="item.idPriority" class="h6 mt-0 mb-0"><i class="fa fa-circle fa-lg mr-2" :style="'color: ' + item.idPriority.backgroundColor"></i></span>
                <span style="visibility: hidden;" v-else class="h6 mt-0 mb-0"><i class="fa fa-circle fa-lg mr-2"></i></span>
                <router-link
                  :to="{name: 'EXCMCaseShow', params: { id: item['@id'] }}">
                  {{item.caseType.title}}
                </router-link>
              </td>
              <td v-if="hasAllowedRoles && ableToManageThisCase(item)">
                <b-dropdown size="sm" variant="link" right text="Right align" toggle-class="text-decoration-none" no-caret>
                  <template #button-content>
                    <i class="fa fa-bars fa-lg"></i>
                  </template>
                  <b-dropdown-item v-if="ableToViewCase" @click="showCase(item['@id'])">
                    <i class="fa fa-search fa-lg"></i>
                    {{ $t('buttons.goto') }}
                  </b-dropdown-item>
                  <b-dropdown-item v-if="ableToEditCase" @click="editCase(item['@id'])">
                    <i class="fa fa-edit fa-lg"></i>
                    {{ $t('buttons.edit') }}
                  </b-dropdown-item>
                  <b-dropdown-item v-if="ableToEditCase && ableToCreateTask" @click="addTask(item['@id'], true)">
                    <i class="fa fa-plus-circle fa-lg"></i>
                    {{ $t('buttons.addTaskWithoutFinishCurrent') }}
                  </b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <section v-if="item.notFinishedTasks && item.notFinishedTasks.length > 1">
                    <template v-for="(notFinishedTask, notFinishedTaskKey) in item.notFinishedTasks">
                      <section :key="notFinishedTaskKey">
                        <b-dropdown-item v-if="ableToCreateTask && ableToAddTask(notFinishedTask)" @click="finishTask(notFinishedTask['@id'])" >
                          <i class="fa fa-check fa-lg"></i>
                          {{notFinishedTask.idTaskType.title}}: {{ $t('buttons.finishTask') }}
                        </b-dropdown-item>
                        <b-dropdown-item v-if="ableToTransferTask(notFinishedTask)" @click="transferTask(notFinishedTask)">
                          <i class="fas fa-exchange-alt fa-lg"></i>
                          {{notFinishedTask.idTaskType.title}}: {{ $t('buttons.transferToAnotherUserDataTask') }}
                        </b-dropdown-item>
                        <b-dropdown-item v-if="ableToReturnTask(notFinishedTask)" @click="taskOperation(notFinishedTask, 'return')">
                          <i class="fas fa-undo-alt fa-lg"></i>
                          {{notFinishedTask.idTaskType.title}}: {{ $t('buttons.returnTask') }}
                        </b-dropdown-item>
                        <b-dropdown-item v-if="ableToTakeTask(notFinishedTask)" @click="taskOperation(notFinishedTask, 'take')">
                          <i class="fas fa-undo-alt fa-lg"></i>
                          {{notFinishedTask.idTaskType.title}}: {{ $t('buttons.takeTask') }}
                        </b-dropdown-item>
                        <b-dropdown-item v-if="notFinishedTask && ableToUpdateTask(notFinishedTask)" @click="editTaskParams(notFinishedTask['@id'])">
                          <i class="fa fa-edit fa-lg"></i>
                          {{notFinishedTask.idTaskType.title}}: {{ $t('buttons.editTaskParams') }}
                        </b-dropdown-item>
                      </section>
                    </template>
                  </section>
                  <template v-else>
                    <b-dropdown-item v-if="ableToCreateTask && ableToAddTask(item.lastTask)" @click="addTask(item['@id'])">
                      <i class="fa fa-plus-circle fa-lg"></i>
                      {{ $t('buttons.finishTaskAndClose') }}
                    </b-dropdown-item>
                    <b-dropdown-item v-if="ableToTransferTask(item.lastTask)" @click="transferTask(item.lastTask)">
                      <i class="fas fa-exchange-alt fa-lg"></i>
                      {{ $t('buttons.transferToAnotherUserDataTask') }}
                    </b-dropdown-item>
                    <b-dropdown-item v-if="ableToReturnTask(item.lastTask)" @click="taskOperation(item.lastTask, 'return')">
                      <i class="fas fa-undo-alt fa-lg"></i>
                      {{ $t('buttons.returnTask') }}
                    </b-dropdown-item>
                    <b-dropdown-item v-if="ableToTakeTask(item.lastTask)" @click="taskOperation(item.lastTask, 'take')">
                      <i class="fas fa-undo-alt fa-lg"></i>
                      {{ $t('buttons.takeTask') }}
                    </b-dropdown-item>
                    <b-dropdown-item v-if="item.lastTask && ableToUpdateTask(item.lastTask)" @click="editTaskParams(item.lastTask['@id'])">
                      <i class="fa fa-edit fa-lg"></i>
                      {{ $t('buttons.editTaskParams') }}
                    </b-dropdown-item>
                  </template>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item v-if="ableToManageCase && isOpenCasesTable" @click="manageCase(item['@id'], 'close')">
                    <i class="fa fa-times fa-lg"></i>
                    {{ $t('buttons.closeCase') }}
                  </b-dropdown-item>
                  <b-dropdown-item v-else-if="ableToManageCase && ableToRevertActions && !isOpenCasesTable" @click="manageCase(item['@id'], 'cancelclose')">
                    <i class="fa fa-check fa-lg"></i>
                    {{ $t('buttons.openAgain') }}
                  </b-dropdown-item>
                  <b-dropdown-item v-if="item.canDelete" @click="deleteItem(item['@id'])">
                    <i class="fa fa-times fa-lg"></i>
                    {{ $t('buttons.delete') }}
                  </b-dropdown-item>
                </b-dropdown>
              </td>
              <td v-else>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        {{$t('views.excmcase.list.noCases')}}
      </div>
    </div>
    <div v-if="view">
    <pagination
      :view="view"
      @getPageNumber="getList($event.page, $event.itemsPerPage)"
      :totalItems="totalItems"
    ></pagination>
    </div>
    <b-dropdown :disabled="selectedItems.length === 0" v-if="isOpenCasesTable && !isWholesaler" size="sm" variant="warning" dropright text="Drop-Right">
      <template #button-content>
        {{ $t('buttons.collectionOperations') }}
      </template>
      <b-dropdown-item @click="createMultipleTasks()"><i class="fa fa-file-check mr-2"></i>{{$t('views.excmcase.list.createMultipleTasks')}}</b-dropdown-item>
      <b-dropdown-item @click="takeMultipleTasks()"><i class="fa fa-file-check mr-2"></i>{{$t('views.excmcase.list.takeMultipleTasks')}}</b-dropdown-item>
    </b-dropdown>
    <CreateMultipleTaskModal @getList="getList()" @reset="resetSelectedItems()" :id-collection="selectedItems"></CreateMultipleTaskModal>
    <create-task-modal @modalHidden="clearSelectedCase()" v-if="selectedItem" :id-case="selectedItem" :add-task-without-finish="addTaskWithoutFinish"></create-task-modal>
    <TransferTaskModal @success="getList()" :task="pickedTask"></TransferTaskModal>
    <UpdateTaskParamsModal v-if="$route.name === 'EXCMCaseList'" :addTask="addTask" @reload="reload()"></UpdateTaskParamsModal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Tag } from 'element-ui'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'
import getId from '../../../../utils/getIdFromLink'
import CreateMultipleTaskModal from '@/components/Dashboard/Views/excmcase/modals/CreateMultipleTaskModal'
import { checkPermission, getUserRoles } from '@/utils/checkRoles'
import CreateTaskModal from '@/components/Dashboard/Views/excmtask/modals/CreateTaskModal'
import ApiService from '@/utils/ApiService'
import Progress from '@/components/UIComponents/Progress'
import addParamsToQuery from '@/utils/addParamsToQuery'
import TransferTaskModal from '@/components/Dashboard/Views/excmtask/modals/TransferTaskModal'
import UpdateTaskParamsModal from '@/components/Dashboard/Views/excmtask/modals/UpdateTaskParamsModal'
import remove from '@/utils/remove'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'
import DeadlineDateInfo from '@/components/Dashboard/Views/excmtask/components/deadlineDateInfo.vue'

export default {
  components: {
    DeadlineDateInfo,
    PhoneNumberLink,
    UpdateTaskParamsModal,
    TransferTaskModal,
    CreateMultipleTaskModal,
    Loader,
    [Tag.name]: Tag,
    Pagination,
    CreateTaskModal,
    Progress
  },

  props: {
    displayAssigned: {
      type: Boolean,
      default () {
        return true
      }
    },
    searchParams: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data () {
    return {
      pickedTask: {},
      selectedItems: [],
      selectedItem: '',
      addTaskWithoutFinish: false,
      order: {
        id: 'desc',
        'lastTask.idTaskType.title': '',
        'caseType.title': '',
        'lastTask.lastPoolTask.operationTransferUserData.surname': '',
        'sortByProgress': '',
        'lastTask.taskSortByProgress': ''
      }
    }
  },
  computed: {
    getUserId () {
      return getUserRoles().id_userdata
    },
    ableToViewCase () {
      return checkPermission('cases', 'EXCMCaseShow')
    },
    isSalesRepresentative () {
      return getUserRoles().roles.includes('ROLE_SALES_REPRESENTATIVE')
    },
    ableToManageCase () {
      return checkPermission('cases', 'EXCMCaseShow', 'caseManage')
    },
    ableToRevertActions () {
      const roles = getUserRoles().roles
      return roles.includes('ROLE_OWNER') || roles.includes('ROLE_SUPER_USER') || roles.includes('ROLE_CONTROLLING')
    },
    ableToEditCase () {
      return checkPermission('cases', 'EXCMCaseUpdate')
    },
    ableToCreateTask () {
      return checkPermission('tasks', 'EXCMTaskCreate') && this.isOpenCasesTable
    },
    isWholesaler () {
      return getUserRoles().roles.includes('ROLE_WHOLESALER')
    },
    hasAllowedRoles () {
      const roles = getUserRoles().roles
      return roles.includes('ROLE_OWNER') || roles.includes('ROLE_SUPER_USER') || roles.includes('ROLE_WHOLESALER') || roles.includes('ROLE_CONTROLLING') || roles.includes('ROLE_DISPATCHER') || roles.includes('ROLE_SALES_REPRESENTATIVE') || roles.includes('ROLE_SERVICEMAN') || roles.includes('ROLE_EXTERNAL_SERVICEMAN')
    },
    searchParamsForApi () {
      let searchParams = JSON.parse(JSON.stringify(this.searchParams))
      if (searchParams['lastTask.lastPoolTask.operationTransferUserData'] === false) {
        searchParams['lastTask.lastPoolTask.operationTransferUserData[exists]'] = false
        searchParams['lastTask.lastPoolTask.operationTransferUserData'] = undefined
      } else {
        searchParams['lastTask.lastPoolTask.operationTransferUserData[exists]'] = undefined
      }
      Object.keys(this.order).forEach(property => {
        if (this.order[property]) {
          searchParams[`order[${property}]`] = this.order[property]
        } else {
          delete searchParams[`order[${property}]`]
        }
      })
      return searchParams
    },
    ...mapGetters({
      deletedItem: 'excmcase/del/deleted',
      error: 'excmcase/list/error',
      items: 'excmcase/list/items',
      isLoading: 'excmcase/list/isLoading',
      view: 'excmcase/list/view',
      totalItems: 'excmcase/list/totalItems',
      multipleTaskCreated: 'excmcase/createMultipleTaskModal/created',
      isCreateTaskModalVisible: 'excmtask/createModal/isVisible',
      createdTask: 'excmtask/create/created'
    }),
    isOpenCasesTable () {
      return this.searchParams.status === 1
    }
  },

  created () {
    this.channelDeliveries = this.$store.state.Pusher.subscribe('e_x_c_m_tasks')
    this.channelDeliveries.bind('e_x_c_m_tasks', data => {
      if (this.$route.name !== 'EXCMCaseList') {
        this.reload()
      }
    })
    // this.getList()
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_c_m_tasks')
  },

  beforeDestroy () {
    this.reset()
    this.resetPage()
  },

  watch: {
    searchParamsForApi: {
      immediate: true,
      deep: true,
      handler () {
        this.getList()
      }
    },
    isCreateTaskModalVisible (val) {
      if (!val && this.createdTask) {
        this.reload()
        this.resetCreatedTask()
      }
    }
  },

  methods: {
    isItemDisabledForSelect (item) {
      let caseTypes = this.selectedItems.map(entry => {
        return getId(entry.caseType['@id'])
      })
      if (this.selectedItems.length === 0) {
        return false
      }
      return !caseTypes.includes(getId(item.caseType['@id']))
    },
    transferTask (task) {
      this.pickedTask = task
      this.toggleTransferModal()
    },
    async taskOperation (task, operation) {
      const decision = await this.$Swal({
        title: operation === 'return' ? this.$t('notifications.excmtask.taskReturn') : this.$t('notifications.excmtask.takeTask'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.no')
      })
      if (decision) {
        const response = await new ApiService(`e_x_c_m_tasks/${getId(task.id)}/${operation}`).put({})
        if (response.status === 200) {
          this.reload()
        }
      }
    },
    editTaskParams (id) {
      this.$store.state.modals.updateTaskParams.show = 1
      this.$store.state.modals.updateTaskParams.path = id
    },
    changeOrder (property) {
      switch (this.order[property]) {
        case '':
          this.order[property] = 'asc'
          break
        case 'asc':
          this.order[property] = 'desc'
          break
        case 'desc':
          this.order[property] = ''
          break
      }
      this.$forceUpdate()
    },
    getProgress (item) {
      if (!item.deadlineDate) {
        return 100
      } else {
        let created = this.$moment(item.createdAt)
        let deadline = this.$moment(item.deadlineDate)
        return this.calculateProgress(created, deadline)
      }
    },
    calculateProgress (created, deadline) {
      let denominator, nominator
      denominator = deadline.diff(created)
      nominator = this.$moment().diff(created)
      return Math.round((nominator / denominator) * 100)
    },
    getLastPoolTaskServiceman (task) {
      if (!task) return ''
      const lastPoolTaskIndex = task.poolTask.length - 1
      if (task.poolTask[lastPoolTaskIndex].operationTransferUserData) {
        return task.poolTask[lastPoolTaskIndex].operationTransferUserData.name + ' ' + task.poolTask[lastPoolTaskIndex].operationTransferUserData.surname
      }
      return ''
    },
    ableToManageThisCase (caseObject) {
      if (this.ableToRevertActions) return true
      if (caseObject.currentOwnerUserData && getId(caseObject.currentOwnerUserData['@id']) === this.getUserId) {
        return true
      }
      if (caseObject.lastTask) {
        let task = caseObject.lastTask
        const lastPoolTaskIndex = task.poolTask.length - 1
        if (!task.poolTask[lastPoolTaskIndex].operationTransferUserData) {
          return true
        }
      }
      if (caseObject.notFinishedTasks && caseObject.notFinishedTasks.length > 0) {
        for (let i = 0; i < caseObject.notFinishedTasks.length; i++) {
          let task = caseObject.notFinishedTasks[i]
          const lastPoolTaskIndex = task.poolTask.length - 1
          if (task.poolTask[lastPoolTaskIndex].operationTransferUserData['@id'] && getId(task.poolTask[lastPoolTaskIndex].operationTransferUserData['@id']) === this.getUserId) {
            return true
          }
        }
      }
      if (caseObject.canDelete) {
        return true
      }
      return false
    },
    ableToReturnTask (task) {
      if (this.isWholesaler) return false
      if (!task) return false
      const lastPoolTaskIndex = task.poolTask.length - 1
      return task.poolTask[lastPoolTaskIndex] ? !!(!this.isFinished(task) && [1, 2, 3].includes(task.poolTask[lastPoolTaskIndex].operation)) : false
    },
    ableToTransferTask (task) {
      if (this.isWholesaler) return false
      if (!task) return false
      const lastPoolTaskIndex = task.poolTask.length - 1
      return task.poolTask[lastPoolTaskIndex] ? !!(!this.isFinished(task) && [1, 2, 3].includes(task.poolTask[lastPoolTaskIndex].operation)) : false
    },
    ableToTakeTask (task) {
      if (this.isWholesaler) return false
      if (!task) return false
      if (!task.canTake) {
        return false
      }
      if (!task.canUpdate) {
        return false
      }
      const lastPoolTaskIndex = task.poolTask.length - 1
      return task.poolTask[lastPoolTaskIndex] ? !!(!this.isFinished(task) && [0].includes(task.poolTask[lastPoolTaskIndex].operation)) : false
    },
    ableToAddTask (task) {
      if (!task.canUpdate) {
        return false
      }
      return true
    },
    ableToUpdateTask (task) {
      return checkPermission('tasks', 'EXCMTaskUpdate') && task.canUpdate && task.finished === 0
    },
    isFinished (task) {
      return task.finished === 1
    },
    showCase (id) {
      this.$router.push({ name: 'EXCMCaseShow', params: { id: id } })
    },
    editCase (id) {
      this.$router.push({ name: 'EXCMCaseUpdate', params: { id: id } })
    },
    addTask (id, addTaskWithoutFinish = false) {
      this.selectedItem = id
      this.addTaskWithoutFinish = addTaskWithoutFinish
      this.toggleCreateTaskModal()
    },
    async finishTask (iri) {
      let id = getId(iri)
      await new ApiService(`e_x_c_m_tasks/${id}/finish`).put({ withoutCreatingNext: 1 })
      this.reload()
    },
    async manageCase (id, operation) {
      let title
      if (operation === 'close') {
        title = this.$t('notifications.excmcase.titleCloseCase')
      } else if (operation === 'cancelclose') {
        title = this.$t('notifications.excmcase.titleOpenCase')
      } else {
        return
      }
      const decision = await this.$Swal({
        title: title,
        text: operation === 'close' ? this.$t('notifications.excmcase.textCloseCase') : '',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      })
      if (decision) {
        let link = `e_x_c_m_cases/${getId(id)}/${operation}`
        const response = await new ApiService(link).put({})
        if (response.status === 200) {
          this.reload()
        }
      }
    },
    reload () {
      this.getPage(this.view['@id'])
      this.$emit('reload')
    },
    getList (page = null, itemsPerPage = undefined) {
      let url = 'e_x_c_m_cases'
      let baseParams = {
        status: this.status,
        '_page': page,
        itemsPerPage: itemsPerPage
      }
      Object.assign(baseParams, this.searchParamsForApi)
      let link = addParamsToQuery(url, baseParams)
      this.getPage(link)
    },
    getIdLink (link) {
      return getId(link)
    },
    deleteItem (itemId) {
      remove(itemId, () => { this.reload() })
    },
    createMultipleTasks () {
      this.toggleCreateMultipleTasksModal()
    },
    async takeMultipleTasks () {
      let params = {
        cases: this.selectedItems.map(entry => {
          return getId(entry['@id'])
        })
      }
      const response = await new ApiService(`e_x_c_m_tasks/take_tasks_multi`).post(params)
      if (response.status === 200 || response.status === 202 || response.status === 207) {
        this.resetSelectedItems()
        this.reload()
      }
    },
    resetSelectedItems () {
      this.selectedItems = []
    },
    clearSelectedCase () {
      this.selectedItem = ''
    },
    isRoleForCustomFieldDisabled (customField) {
      if (customField.disabledRoles && customField.disabledRoles.length > 0) {
        let idClientType = getUserRoles().id_client_type
        if (customField.disabledRoles.includes(idClientType)) {
          return true
        }
      }
      return false
    },
    ...mapMutations({
      toggleTransferModal: 'excmtask/transferModal/toggleModal',
      toggleCreateMultipleTasksModal: 'excmcase/createMultipleTaskModal/toggleCreateMultipleTaskModal',
      toggleCreateTaskModal: 'excmtask/createModal/toggleModal',
      resetPage: 'excmcase/list/reset'
    }),
    ...mapActions({
      getPage: 'excmcase/list/fetchCases',
      reset: 'excmcase/createMultipleTaskModal/reset',
      resetCreatedTask: 'excmtask/create/reset'
    })
  }
}
</script>
<style scoped>
.th-link:hover {
  text-decoration: underline;
  cursor: pointer
}
</style>
